import { Component, Input } from '@angular/core';
import { UssdApplicationFormComponent } from '../application-form/application-form.component';

/** /applications/:id/edit — the shared application wizard in edit mode. */
@Component({
  selector: 'app-edit-application',
  standalone: true,
  imports: [UssdApplicationFormComponent],
  templateUrl: './edit-application.component.html',
  styleUrl: './edit-application.component.css',
})
export class EditApplicationComponent {
  /** Route param, bound by withComponentInputBinding. */
  @Input() id!: string;
}
